import {
  WbsItemStatus,
  WbsItemType,
} from '../../../domain/entity/WbsItemEntity'
import { UserBasic } from '../../../domain/value-object/UserBasicVO'
import {
  WbsItemTypeObject,
  WbsItemTypeVO,
} from '../../../domain/value-object/WbsItemTypeVO'
import { CUSTOM_ENUM_NONE } from '../../../lib/commons/customEnum'
import { ProjectDetail } from '../../../lib/functions/project'
import { ProjectMemberProps } from '../../../lib/functions/projectMember'
import { ProjectPlanCumulation } from '../../../lib/functions/projectPlan'
import { SprintDetail } from '../../../lib/functions/sprint'
import { TagForWbsItem } from '../../../lib/functions/tag'
import { TeamProps } from '../../../lib/functions/team'
import store from '../../../store'
import { CommentSummary } from '../../../store/comments'
import { AttachmentSummary } from '../../../utils/attachment'
import { DateTerm } from '../../../utils/date'

export interface Row {
  uuid: string
  lockVersion?: number
  rowNumber: number
}

export class TaskActualWorkProxyRegistrationData {
  uuid: string
  lockVersion: number

  projectUuid: string
  code?: string
  type: WbsItemType
  typeDto: WbsItemTypeObject
  baseTypeDto: WbsItemTypeObject
  displayName?: string
  description?: string
  team?: TeamProps
  accountable?: ProjectMemberProps
  responsible?: ProjectMemberProps
  assignee?: ProjectMemberProps
  estimatedStoryPoint?: number
  estimatedHour?: number
  priority?: string
  difficulty?: string
  scheduledDate?: DateTerm
  actualDate?: DateTerm
  actualHour?: number
  status?: string
  substatus?: string
  estimatedAmount?: number
  actualAmount?: number
  ticketType?: string
  ticketListUuid?: string
  watchers?: ProjectMemberProps[]
  revision?: string
  createdAt?: number
  createdBy?: UserBasic
  updatedAt?: number
  updatedBy?: UserBasic

  project: ProjectDetail
  path: string
  parentWbsItem: TaskActualWorkProxyRegistrationWbsItem
  cumulation?: ProjectPlanCumulation
  sprint?: SprintDetail
  sprints?: SprintDetail[]
  commentSummary?: CommentSummary
  deliverableAttachmentSummary?: AttachmentSummary
  actualWorks?: ActualWork[]
  tags?: TagForWbsItem[]
}

export interface TaskActualWorkProxyRegistrationRow extends Row {
  type?: WbsItemType
  body?: TaskActualWorkProxyRegistrationRowBody
  edited?: boolean
  editedData?: { [key: string]: any }
}

export class TaskActualWorkProxyRegistrationRowBody {
  type: WbsItemType
  wbsItemUuid: string
  wbsItem: TaskActualWorkProxyRegistrationWbsItem
  path: string
  parentWbsItem: TaskActualWorkProxyRegistrationWbsItem
  actualWorks?: ActualWork[]

  constructor(src: TaskActualWorkProxyRegistrationData) {
    this.wbsItem = {
      projectUuid: src.projectUuid,
      uuid: src.uuid,
      lockVersion: src.lockVersion,

      code: src.code,
      type: src.type,
      wbsItemType: src.typeDto
        ? new WbsItemTypeVO(src.typeDto)
        : store.getState().project.wbsItemTypes.get(src.type)!,
      baseWbsItemType: src.baseTypeDto
        ? new WbsItemTypeVO(src.baseTypeDto)
        : store.getState().project.wbsItemTypes.get(src.type)!,
      displayName: src.displayName,
      status: src.status ? (src.status as WbsItemStatus) : undefined,
      substatus: src.substatus === CUSTOM_ENUM_NONE ? undefined : src.substatus,
      priority: src.priority === CUSTOM_ENUM_NONE ? undefined : src.priority,
      difficulty:
        src.difficulty === CUSTOM_ENUM_NONE ? undefined : src.difficulty,
      description: src.description ?? '',
      team: src.team,
      accountable: src.accountable,
      responsible: src.responsible,
      assignee: src.assignee,
      estimatedStoryPoint: src.estimatedStoryPoint,
      estimatedHour: src.estimatedHour,
      scheduledDate: {
        startDate: src.scheduledDate?.startDate,
        endDate: src.scheduledDate?.endDate,
      },
      actualDate: {
        startDate: src.actualDate?.startDate,
        endDate: src.actualDate?.endDate,
      },

      actualHour: src.actualHour,

      estimatedAmount: src.estimatedAmount,
      actualAmount: src.actualAmount,

      ticketType:
        src.ticketType === CUSTOM_ENUM_NONE ? undefined : src.ticketType,
      ticketListUuid: src.ticketListUuid,

      watchers: src.watchers,
      tags: src.tags,

      revision: src.revision,
      updatedAt: src.updatedAt,
      updatedBy: src.updatedBy,
      createdAt: src.createdAt,
      createdBy: src.createdBy,
      sprint: src.sprint,
      sprints: src.sprints,
    }
    this.path = src.path
    this.parentWbsItem = src.parentWbsItem
    this.actualWorks = src.actualWorks
  }
}

export class TaskActualWorkProxyRegistrationWbsItem {
  uuid?: string
  lockVersion?: number
  projectUuid: string

  code?: string
  type: WbsItemType
  wbsItemType: WbsItemTypeVO
  baseWbsItemType: WbsItemTypeVO
  displayName?: string
  description?: string
  team?: TeamProps
  accountable?: ProjectMemberProps
  responsible?: ProjectMemberProps
  assignee?: ProjectMemberProps
  estimatedStoryPoint?: number
  estimatedHour?: number
  priority?: string
  difficulty?: string
  scheduledDate?: DateTerm
  actualDate?: DateTerm
  actualHour?: number
  status?: WbsItemStatus
  substatus?: string

  estimatedAmount?: number
  actualAmount?: number

  ticketType?: string
  ticketListUuid?: string

  watchers?: ProjectMemberProps[]
  tags?: TagForWbsItem[]

  revision?: string
  createdAt?: number
  createdBy?: UserBasic
  updatedAt?: number
  updatedBy?: UserBasic

  sprint?: SprintDetail
  sprints?: SprintDetail[]
}

export interface ActualWork {
  uuid: string
  lockVersion: number
  hour: number
  actualDate: string
  isEdited: boolean
}
